let base = process.env.REACT_APP_API_URL || "http://localhost:3001";
if (!base.endsWith("/api")) {
  base = base.replace(/\/+$/, "") + "/api";
}
const API_BASE_URL = base;

const dashboardService = {
  getDashboardData: async () => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_BASE_URL}/dashboard/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch dashboard data");
    }
    return data;
  },
};

export default dashboardService;
